import { ContractFilterInput, OrderDirectionOption, PageSizeOption } from '@/graphql/generated';

export const MONTHS_ES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const initialContractRoadmapFilters: ContractFilterInput = {
  status: null,
  signed: null,
  leaseTerm: null,
  orderDirection: OrderDirectionOption.Desc,
  search: null,
  pageSize: PageSizeOption.Fifty,
  page: null,
  startMonth: null,
  endMonth: null,
};

